import { Button } from "antd";
import { Link } from "react-router-dom";
import RefreshList from "./newSetting";

/**
 * Controls component renders a UI section with app and setting information and control buttons.
 *
 * @param {Object} props - The properties object.
 * @param {Object} props.app - The app data object containing the id and name.
 * @param {Object} props.setting - The setting data object containing the name.
 * @param {Object} props.activeNewSetting - The active new setting object.
 * @param {Function} props.toggleNewSetting - Function to toggle the new setting.
 * @param {Function} props.refresh - Function to refresh the list.
 * @param {Function} props.setActiveNewSetting - Function to set the active new setting.
 *
 * @returns {JSX.Element} The rendered Controls component.
 */
export default function Controls({
  app,
  setting,
  activeNewSetting,
  toggleNewSetting,
  refresh,
  setActiveNewSetting,
}) {
  return (
    <div className="controls">
      <div className="icon"> </div>

      {setting ? (
        <div className="title">
          <Link to={`/apps/${app.id}`}>{app.name}</Link>
          <span className="separator">{">"}</span>
          <h1>{setting.name}</h1>
        </div>
      ) : (
        <div className="title">
          <h1>{app.name}</h1>
        </div>
      )}

      <div className="controlButtons">
        {setting ? <div /> : ""}
        {activeNewSetting ? (
          <RefreshList
            refresh={refresh}
            newSetting={activeNewSetting}
            setNewSetting={setActiveNewSetting}
          />
        ) : (
          ""
        )}
        <Button type="primary" onClick={() => toggleNewSetting()}>
          New Channel
        </Button>
      </div>
    </div>
  );
}
